import axios from "../../../../axios";
import Cookies from "js-cookie";

export const getSentCandidates = async () => {
  const token = Cookies.get("ConsultantToken");

  return axios.post("/api/Consultant/GetSentCandidates", {
    token,
  });
};